import { render, staticRenderFns } from "./StepAdminSpaNavigationDrawer.vue?vue&type=template&id=23e7b4be"
import script from "./StepAdminSpaNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./StepAdminSpaNavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./StepAdminSpaNavigationDrawer.vue?vue&type=style&index=0&id=23e7b4be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports